export default __webpack_public_path__ + "static/media/desktopHero.8c2ca7ec.png";